import { render, staticRenderFns } from "./KitTagsPanel.vue?vue&type=template&id=6b0d418c&scoped=true"
import script from "./KitTagsPanel.vue?vue&type=script&lang=js"
export * from "./KitTagsPanel.vue?vue&type=script&lang=js"
import style0 from "./KitTagsPanel.vue?vue&type=style&index=0&id=6b0d418c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0d418c",
  null
  
)

export default component.exports